import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
// import { faBell } from '@fortawesome/free-regular-svg-icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Button, Navbar, Nav, NavDropdown, Badge } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import { RootState } from '../store/rootReducer';

interface Props {
  sidebarOpen: boolean;
  setSidebarOpen: (v: boolean) => void;
}

const Header: React.FC<Props> = ({ setSidebarOpen, sidebarOpen }: Props) => {
  // const [notificationOpen, setNotificationOpen] = useState(false);
  // const [dropdownOpen, setDropdownOpen] = useState(false);
  const { currentUser, currentUserInitials } = useSelector((state: RootState) => state.auth);
  const { t } = useTranslation(['header', 'common']);

  return (
    <Navbar bg="white" className="topbar mb-4 static-top shadow">
      <Button id="sidebarToggleTop" variant="link" className="d-md-none rounded-circle mr-3" onClick={() => setSidebarOpen(!sidebarOpen)}>
        <FontAwesomeIcon className="nav-link-icon" icon={faBars} fixedWidth />
      </Button>

      {/* <div v-if="title" class="my-2 ml-md-3" style="font-size: 1.25rem;">
       {{ title }}
  </div> */}

      <Nav className="ml-auto">
        <div className="topbar-divider d-none d-sm-block" />
        <NavDropdown
          title={
            <>
              <span className="mr-2 d-none d-lg-inline text-gray-600 small">{currentUser && currentUser.name}</span>
              <Badge
                variant="primary"
                pill
                className="font-weight-normal"
                style={{ padding: '0.5em', borderRadius: '50%', fontSize: '0.75rem', lineHeight: 'inherit', minWidth: '2.6em' }}
              >
                {currentUserInitials && currentUserInitials}
              </Badge>
            </>
          }
          id="basic-nav-dropdown"
          className="no-arrow"
        >
          <Link to="/logout" className="dropdown-item">
            <FontAwesomeIcon icon={faSignOutAlt} fixedWidth size="sm" className="mr-2 text-gray-400" /> {t('logout')}
          </Link>
        </NavDropdown>
      </Nav>
    </Navbar>
  );
};

export default Header;
